import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';


export default function layoutReducer(state = initialState.layout, action) {
  switch (action.type) {
    case types.EXPAND_MENU:
      return objectAssign({}, state, { expandMenu: true });

    case types.COLLAPSE_MENU:
      return objectAssign({}, state, { expandMenu: false });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/layoutReducer.js